import Learnove from '../assets/Learnova.png'
import ROCKETACME from '../assets/Rocket_Acme.jpeg'
import TuneSpy from '../assets/TuneSpy.png'
import Scopedia from '../assets/Scopedia.png'
import FChat from '../assets/Chat-Ease.png'
import BeamForming from '../assets/BeamForming.png'
import SampleStudio from '../assets/SampleStudio.png'
import SignalEqualizer from '../assets/SignalEqualizer.png'
import Filtra from '../assets/filtra.png'
import Hnadilingo from '../assets/Hnadilingo.png'
import redisMonitor from '../assets/redis_monitor.png'
import SignalViwer from '../assets/Signal_Viewer.png'
import ACTIVEPLUSE from '../assets/ActivePluse.png'
import WORKSPHERE from '../assets/WorkSphere.png'
import JOBTRACKER from '../assets/JobTracker.png'
import WEATHERDASHBOARD from '../assets/WeatherDashboard.png'
import AwsTerraform from '../assets/aws-terraform.png'

export const data=[
    {
        id:1,
        name:"Learnova - LMS Platform",
        image: Learnove, 
        github:"https://github.com/ahmed-226/Learnova",
        live:"",
        description: "Complete Learning Management System with video streaming and progress tracking",
        tech: ["React", "Node.js", "MongoDB", "Express", "Redis"]
    },{
        id:2,
        name: "aws-terraform",
        image:AwsTerraform,
        github:"https://github.com/ahmed-226/aws-terraform",
        live:"",
        description: "This project creates a VPC with public and private subnets, bastion host, and a private EC2 instance running a Node.js server.",
        tech: ["Terraform", "AWS" ]
    },
    {
        id:3,
        name:"Sociopedia - Social Media",
        image:Scopedia,
        github:"https://github.com/ahmed-226/Sociopedia",
        live:"https://sociopedia-client-ztmd.onrender.com/",
        description: "Full-stack social media platform with MERN stack",
        tech: ["React", "MongoDB", "Express", "Node.js", "Material-UI"]
    },
    {
        id:4,
        name:"Chat-Ease - Real-time Chat",
        image:FChat,
        github:"https://github.com/ahmed-226/Chat-Ease",
        live:"",
        description: "Real-time chat application with Socket.io and React",
        tech: ["React", "Socket.io", "Node.js", "MongoDB"]
    },
    {
        id:12,
        name:"Active Pluse",
        image:ACTIVEPLUSE,
        github:"https://github.com/ahmed-226/Active-Pluse",
        live:"",
        description: "A comprehensive fitness tracking application built with React and Vite, featuring workout logging, meal tracking, progress analytics, and goal management",
        tech: ["React", "Vite", "Tailwind CSS"]
    },
    {
        id:13,
        name:"WorkSphere",
        image:WORKSPHERE,
        github:"https://github.com/ahmed-226/WorkSphere",
        live:"",
        description: "WorkSphere is a comprehensive dashboard application designed for freelancers to manage their projects, track activities, and monitor earnings.",
        tech: ["React", "Redux", "Tailwind CSS"]
    },
    {
        id:14,
        name:"Job Tracker",
        image:JOBTRACKER,
        github:"https://github.com/ahmed-226/Job-Tracker",
        live:"",
        description: "A full-featured, responsive web application built with React, Vite, Redux Toolkit, and Tailwind CSS that allows users to track their job applications.",
        tech: ["React", "Redux Toolkit", "Vite", "Tailwind CSS"]
    },
    {
        id:15,
        name:"Weather Dashboard",
        image:WEATHERDASHBOARD,
        github:"https://github.com/ahmed-226/Elevvo-internship/tree/main/task_7",
        live:"",
        description: "A modern, responsive weather dashboard that provides real-time weather information for any city worldwide. This project demonstrates API integration, geolocation services, and dynamic data visualization with a clean, minimal user interface.",
        tech: ["React", "API Integration", "Tailwind CSS"]
    },
    {
        id:5,
        name:"HandiLingo - Sign Language",
        image:Hnadilingo,
        github:"https://github.com/ahmed-226/HandiLingo",
        live:"",
        description: "Sign language learning platform with gesture recognition",
        tech: ["Python", "OpenCV", "TensorFlow", "React"]
    },
    {
        id:6,
        name:"Heart Care System",
        image:BeamForming,
        github:"https://github.com/ahmed-226/BeamForming",
        live:"",
        description: "Hospital Information System for cardiac care management",
        tech: ["Python", "Qt5", "PostgreSQL"]
    },
    {
        id:7,
        name:"Filtra - Image Processing",
        image:Filtra, 
        github:"https://github.com/HarmoniCode/Filtra",
        live:"",
        description: "Advanced image filtering and processing application",
        tech: ["Python", "Qt5", "OpenCV"]
    },
    {
        id:8,
        name:"TuneSpy - Music Analysis",
        image:TuneSpy, 
        github:"https://github.com/HarmoniCode/TuneSpy",
        live:"",
        description: "Music analysis and recommendation system",
        tech: ["Python", "Qt5", "NumPy"]
    },
    {
        id:9,
        name:"Sample Studio",
        image:SampleStudio,
        github:"https://github.com/HarmoniCode/Sampling-Studio",
        live:"",
        description: "Digital signal processing and audio sampling studio",
        tech: ["Python", "Qt5", "SciPy"]
    },
    {
        id:10,
        name:"Equalizer",
        image:SignalEqualizer,
        github:"https://github.com/HarmoniCode/Signal_Equalizer",
        live:"",
        description: "Audio equalization and sound enhancement tool",
        tech: ["Python", "Qt5", "NumPy"]
    },
    {
        id:11,
        name:"Signal Viewer",
        image:SignalViwer,
        github:"https://github.com/HarmoniCode/Signal-Viewer",
        live:"",
        description: "Signal visualization and analysis tool",
        tech: ["Python", "Qt5", "Matplotlib"]
    },{
        id:12,
        name:"Redis Monitor Dashboard",
        image:redisMonitor, 
        github:"https://github.com/ahmed-226/redis-monitor-dashboard",
        live:"",
        description: "Real-time Redis monitoring dashboard with performance metrics",
        tech: ["React", "Redis", "Docker", "Node.js"]
    }
]